/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconChevronsRight = createReactComponent("chevrons-right", "IconChevronsRight", [
  ["path", { d: "M7 7l5 5l-5 5", key: "svg-0" }],
  ["path", { d: "M13 7l5 5l-5 5", key: "svg-1" }]
]);

export { IconChevronsRight as default };
//# sourceMappingURL=IconChevronsRight.js.map
